// addresses modules
import axios from 'axios';
import { ADDRESS_URL, DEFAULT_ADDRESS_URL } from '../../api/url.js';
import { STATES } from '../../../config/default';

// initial state
const state = {
  customerDetails: [],
  defaultAddress: {},
  states: STATES,
  // successfullyPosted: false,
}

// actions
const actions = {
  // fetchAddresses
  async fetchAddresses(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: ADDRESS_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    await axios(config) 
    .then((response) => {
      context.commit('fetchAddresses', response.data);
    }, (err) => {
      console.log("fetchAddresses error:", err);
    })
  },
  // fetchAddresses
  async fetchDefaultAddress(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: DEFAULT_ADDRESS_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
  await axios(config) 
    .then((response) => {
      context.commit('fetchDefaultAddress', response.data);
    }, (err) => {
      console.log("fetchDefaultAddress error:", err);
    })
  },
  // postAddress
  async postAddress({ commit, dispatch }, data) {
    let address, type;
    if (!Array.isArray(data)) {
      address = data;
    } else {
      address = data[0];
      type = data[1];
    }
    const token = localStorage.getItem('token');
    const config = {
      method: 'post',
      url: ADDRESS_URL,
      data: address,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    axios(config) 
    .then((response) => {
      dispatch('fetchAddresses');
    }, (err) => {
      if (err.response.data='Not support PO BOX.') {
        alert('We do not support PO BOX addresses, please use another address.');
      }
      alert('error happen when create address, please contact us.');
    })
  },
  // editAddress
  editAddress(context,[address, customerDetail_id]) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'put',
      url: `${ADDRESS_URL}/${customerDetail_id}`,
      data: address,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    axios(config) 
    .then((response) => {
      // location.reload();
    }, (err) => {
      if (err.response.data='Not support PO BOX.') {
        alert('We do not support PO BOX address, please use another address.');
      }
      alert('error happen when edit address, please contact us.');
    })
  },
  // deleteAddress
  deleteAddress({ dispatch }, customerDetail_id) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'delete',
      url: `${ADDRESS_URL}/${customerDetail_id}`,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    axios(config) 
    .then((response) => {
      dispatch('fetchAddresses')
      // location.reload();
    }, (err) => {
      alert('error happen when delete address, please contact us.');
    })
  },
};

// mutations
const mutations = {
  fetchAddresses(state, payload) {
    state.customerDetails = payload.Customer_Detail
  },
  fetchDefaultAddress(state, payload) {
    state.defaultAddress = payload
  }
}

export default {
  strict: true,
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses.js